enum ScheduledActionTypeEnum {
	Cron = 'Cron',
	DateTime = 'DateTime',
}
export default ScheduledActionTypeEnum;
